import type { CartGetData } from 'src/types/cart';

export const isDisabledRetailer = (cart: CartGetData) => cart?.vendorStatus === 'disabled';
